var $=jQuery;
$('.ProductListWrapper').on('click', '.ProductItem', function() {
      // 排除 .ProductItem_pic_title 区域内的点击（包括其内部元素）
    if ($(event.target).closest('picture', this).length > 0) {
        return;
    }
    console.log('点击01');
    var product_name =  $(this).find('.ptit').text();
    var product_id = $(this).attr('data-product-id');
    var product_type = 'productClick';
    var category = '';
    var collection_name ='';
    if (window.location.pathname == '/') {
      category = 'HomePage';
    } 
    if(url.indexOf("/collections") >= 0 ) { 
        category = 'productList';
        // 提取 collections 后的部分
        var match = url.match(/\/collections\/([^/?#]+)/);
        if (match && match[1]) {
            var collection_slug = match[1];
            collection_name = 'proList_' + collection_slug;
        }
        gtag_product_click(category, collection_name, product_type, product_name, product_id);

    }
    if(url.indexOf("/products") >= 0 ) { 
      category = 'productDetail';
      if(jQuery(window).width()>=769){
        if($(this).closest('.may_like').hasClass('pc_may_like')){
            collection_name = 'ProductDetail_Recommendation_recommend';
            gtag_product_click(category,collection_name,product_type,product_name,product_id);
        }
      }
    }
    if($(this).closest('section').hasClass('best_sale')){
      console.log('点击best selling的产品');
        collection_name = 'HomePage_Top Sale';
        gtag_product_click(category,collection_name,product_type,product_name,product_id);
    }
    if($(this).closest('section').hasClass('home_slide1')){
        collection_name = 'HomePage_Flash Sale';
        gtag_product_click(category,collection_name,product_type,product_name,product_id);
    }
    if($(this).closest('section').hasClass('home-recommend-section')){
        collection_name = 'HomePage_Recommend';
        gtag_product_click(category,collection_name,product_type,product_name,product_id);
    }
    if(jQuery(window).width()<=768){
        if($(this).closest('section').hasClass('detail_recommend_slide_m')){
            collection_name = 'ProductDetail_Recommendation_recommend';
            gtag_product_click(category,collection_name,product_type,product_name,product_id);
        }
    }
      
    console.log('点击的所属分类名称',collection_name);
    const dataToStore = {
        selected_category_title: collection_name,
    };
    localStorage.setItem('selected_product_info', JSON.stringify(dataToStore));
    
})
// 点击事件
function gtag_product_click(category,collection_name,product_type,product_name,product_id) {
  console.log('我传的，哈哈哈',collection_name);
    gtag('event', 'select_item', {
        "event_category":category,
        "event_label":collection_name,
        "event_action":product_type,
        'send_to': 'G-F0NKM0YQCD',
        "items": [
          {
            "item_id": product_id,
            "item_name": product_name,
            "item_list_name":collection_name
          }
        ],
      });
}
// 曝光事件 

window.gtag_product_view = function(category,collection_name,product_type,product_name,product_id) {
  gtag('event', 'view_item_list', {
      "event_category":category,
      "event_label":collection_name,
      "event_action":product_type,
      'send_to': 'G-F0NKM0YQCD',
      "items": [
        {
          "item_id": product_id,
          "item_name": product_name,
          "item_list_name":collection_name
        }
      ],
    });
}